<script>
import Navbar from '../components/Navbar';
import Loader from '../components/Loader';
import Footer from '../components/Footer';


export default {
    components: {
        Navbar,
        Loader,
        Footer,
    },

    metaInfo() {
        return {
            title: this.title,
        };
    },

    props: {
        typeFilter: String,
    },

    data() {
        return {
            page: 1,
            title: "Retailers",
            isLoading: false,
            retailers: [],
            searchTerm: '',
            isMore: true,
        };
    },

    computed: {
        groupedRetailers() {
            const filteredRetailers = this.retailers;

            return filteredRetailers.reduce((groups, retailer) => {
                const firstLetter = retailer.name[0].toUpperCase();
                if (!groups[firstLetter]) {
                    groups[firstLetter] = [];
                }
                groups[firstLetter].push(retailer);
                return groups;
            }, {});
        },
    },

    async mounted() {
        this.loadMoreRetailers();
    },

    methods: {
        toggleRetailersFilter(retailerName) {
            this.$router.push('/?retailer=' + retailerName);
        },

        searchRetailer() {
            this.page = 1;
            this.retailers = [];
            this.isMore = true;
            this.loadMoreRetailers();
        },

        async loadMoreRetailers() {
            this.isLoading = true;

            const retailers = await window.axios.get('/api/retailers/all',
                { params: { page: this.page, search: this.searchTerm } });
            this.retailers = this.retailers.concat(retailers.data.data);
            this.page += 1;

            if (retailers.data.data.length === 0) {
                this.isMore = false;
            }


            this.isLoading = false;
        },
    },

};
</script>

<template lang='pug'>
.page-wrapper
    Navbar
    .content-wrapper

        .content
            h1
                span Retailers
            h4 Share deals and vouchers from any of the following retailers marked green
                |  and you'll earn cashback when a sale occurs

        .retailer-search-wrapper
            form(@submit.prevent)
                input(v-model='searchTerm' placeholder='Search for a retailer...')
                button(@click='searchRetailer' type='submit') Search


        .retailers(v-for="(group, letter) in groupedRetailers")

            h3 {{letter}}

            .retailer(
                v-for="retailer in group"
                :key="retailer.id"
                :class="{'is-cashback': retailer.driver == 'AWIN' || retailer.driver == 'DIGIDIP'}"
                @click='toggleRetailersFilter(retailer.name)'
                ) {{ retailer.name }}

        .load-more-wrapper
            button(@click="loadMoreRetailers" v-if='!isLoading && isMore') Load More
        Loader(v-if='isLoading')



    Footer
</template>

<style lang='stylus' scoped>
@import "../../stylus/mixins.styl";
@import "../../stylus/variables.styl";

.content-wrapper
    flexbox(column, center, center)
    margin 30px 0px
    max-width: 100%
    // width 100vw

    .retailer-search-wrapper
        form
            flexbox(row, center, center)
        input
            width: 100%
            padding 10px 20px
            border-radius 4px
            box-shadow none
            border none

        button
            width 100px
            padding 10px 20px
            background-color $dark-green
            color white
            border-radius: 5px
            margin-left 5px
    .content
        padding: 0px 20px
    .retailers
        min-width 300px
        max-width 800px
        margin 0px 30px
        width 50%
        flexbox(column, flex-start, center)
        flex-grow grow

        h3
            align-self flex-start
            margin 10px 0px
        flex-wrap wrap

        .retailer
            width 90%
            margin 2px
            padding 10px 12px
            box-shadow 0px 4px 2px rgba(0, 0, 0, 0.05)
            border-radius 10px

            cursor pointer
            background #ffffff
            color:585858
            overflow:hidden

            &.is-cashback
                background: $dark-green
                color white
    .load-more-wrapper
        padding 20px

        button
            padding 5px 20px
            background-color:$dark-green
            color white
            border-radius 5px
    .list-enter-active,
    .list-leave-active {
    transition: all 0.5s ease;
    }
    .list-enter-from,
    .list-leave-to {
    opacity: 0;
    transform: translateX(30px);
    }
</style>

